import { render, staticRenderFns } from "./TemplateMessages.vue?vue&type=template&id=66d94b73&scoped=true"
import script from "./TemplateMessages.vue?vue&type=script&lang=js"
export * from "./TemplateMessages.vue?vue&type=script&lang=js"
import style0 from "./TemplateMessages.vue?vue&type=style&index=0&id=66d94b73&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66d94b73",
  null
  
)

export default component.exports